import React, { useRef } from 'react';
import CookieConsent from 'react-cookie-consent';

import Button from '../Button/Button';
import ButtonGroup from '../ButtonGroup/ButtonGroup';
import Content from '../Content/Content';
import * as styles from './CookieConsent.module.css';

const CookieConsentPopup = ({ privacyNotice = '/privacy-notice' }) => {
	const cookieConsentRef = useRef(null);

	const isBrowser = typeof window !== 'undefined';
	if (!isBrowser) return null;

	return (
		<CookieConsent
			ref={cookieConsentRef}
			location="none"
			buttonText="Accept"
			disableStyles={true}
			containerClasses={styles.box}
			overlay={location.pathname !== privacyNotice ? true : false}
			overlayClasses={styles.overlay}
			cookieName="gdpr-google-analytics">
			<div className={styles.content}>
				<Content theme="space">
					<p>
						We use cookies and other tracking technologies to improve your
						browsing experience on our website to analyse our website traffic,
						and to understand where our visitors are coming from.
					</p>
					<ButtonGroup align="center">
						<Button to={privacyNotice} theme="ghost">
							Learn more
						</Button>
						<Button
							aria-label="Decline cookies"
							onClick={() =>
								null !== cookieConsentRef.current &&
								cookieConsentRef.current.decline()
							}>
							Decline
						</Button>
						<Button
							aria-label="Accept cookies"
							onClick={() =>
								null !== cookieConsentRef.current &&
								cookieConsentRef.current.accept()
							}>
							Accept
						</Button>
					</ButtonGroup>
				</Content>
			</div>
		</CookieConsent>
	);
};

export default CookieConsentPopup;
